<template>
  <div class="topic-list__container">
    <b-alert :show="ui.topics.error || ui.cms.error"
             variant="danger"
             class="alert m-auto">
      <template v-if="ui.topics.error">
        {{ ui.topics.errorMessage }}
      </template>
      <template v-if="ui.cms.error">
        {{ ui.cms.errorMessage }}
      </template>
    </b-alert>
    <loading-spinner v-if="ui.topics.loading || ui.cms.error"
                     class="m-auto"
                     size="2x">
    </loading-spinner>
    <transition name="fade">
      <div v-if="ui.topics.loading == false"
           class="topic-list">
        <topic-card v-for="topic in mappedTopics"
                    :key="topic.topic"
                    class="topic-list__card"
                    :topic-id="topic.topicId"
                    :title="topic.topicName"
                    :status="topic.topicUserStatusSystemCode"
                    :search-text="topic.searchDescription"
                    :thumbnail="topic.thumbnail"
                    :alt-card-style="altCardStyle"></topic-card>
      </div>
    </transition>
  </div>
</template>
<script>

import TopicCard from "~/Components/Topic/TopicCard.vue";
import { arrayContentsContainsAllKeys } from "~/Scripts/modules/utils";

import {
  listUserTopics,
  listCmsTopicData,
} from "~/Scripts/resources/topicResource";

export default {
  name: "TopicList",
  components: {
    TopicCard,
  },
  props: {
    moduleId: {
      type: Number,
      default: undefined,
    },
    cmsMap: {
      type: Array,
      default: () => ( [] ),
      // eslint-disable-next-line
      validator: function ( val ) {
        const schema = ["id", "searchDescription", "thumbnail"];
        return arrayContentsContainsAllKeys( val, schema );
      },
    },
    altCardStyle: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ( {
    topics: [],
    ui: {
      topics: {
        loading: false,
        error: false,
        errorMessage: "Ooops something went wrong! Please, try again.",
      },
      cms: {
        loading: false,
        error: false,
        errorMessage: "Ooops something went wrong! Please, try again.",
      },
    },
    cmsData: [],
  } ),
  computed: {
    mappedTopics () {
      //  return this.cmsData.map( cmsData => {
      //    const topic = this.topics.find( t => t.topicId === cmsData.id );
      //    const { searchDescription, thumbnail } = cmsData || {};
      //    const mutableTopic = { ...topic, searchDescription, thumbnail };
      //    return mutableTopic;
      //  } );

      return this.topics.map( topic => {
        const cms = this.cmsData.find( cmsData => cmsData.id === topic.topicId );
        const { searchDescription, thumbnail } = cms || {};
        const mutableTopic = { ...topic, searchDescription, thumbnail };
        return mutableTopic;
      } );
    },
  },
  watch: {
    moduleId ( id ) {
      this.getUserTopics( id );
    },
  },
  created () {
    if ( this.cmsMap.length === 0 ) {
      this.getTopicCmsMap();
    } else {
      this.cmsData = this.cmsMap;
    }

    this.getUserTopics( this.moduleId );
  },
  methods: {
    getTopicCmsMap () {
      this.ui.cms.loading = true;

      listCmsTopicData().then( response => {
        const { data } = response;
        this.cmsData = data;
      } ).catch( ex => {
        console.error( ex );
        this.ui.cms.error = true;
      } ).finally( () => {
        this.ui.cms.loading = false;
      } );
    },
    getUserTopics ( moduleId ) {
      this.ui.topics.loading = true;

      listUserTopics( moduleId ).then( response => {
        const { data } = response;
        this.topics = data;
      } ).catch( ex => {
        console.error( ex );
        this.ui.topics.error = true;
      } ).finally( () => {
        this.ui.topics.loading = false;
      } );
    },
  },
};
</script>

<style lang="less" scoped>
  @import "../../Styles/utils/index.less";

  @gap: 2%;

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 1s
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0
  }

  .topic-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;

    @media ( max-width: @lg ) {
      justify-content: center;
    }

    &__card {
      flex: 0 0 calc( 25% - @gap );
      min-width: 220px;
      margin-right: @gap;

      &:last-child {
        margin-right: 0;
      }

      @media ( max-width: @lg ) {
        flex-basis: calc( 50% - @gap );

        &:nth-child( 2n ) {
          margin-right: 0;
        }
      }

      @media ( max-width: 767px ) {
        margin-right: 0;
      }
    }
  }
</style>
